import { PaginationType } from "../interface/PaginationInterface";

export const paginationInit: PaginationType = {
    page: 1,
  };
  